export default __webpack_public_path__ + "static/media/orbitLogo.d667a2eb.png";